import Request from "../../utils/Request";
import {AxiosResponse} from "axios";

/**
 * @param data
 * @returns {Promise<AxiosResponse<*>>}
 * @constructor
 */
const GetCompaniesRequest = (data: any[] = {}): Promise<AxiosResponse<any>> =>
    Request.get(`/employers/search?${Request.parseParams(data)}`);

/**
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export default GetCompaniesRequest;